<template>
  <div class="all">
    <Header></Header>
    <div class="top-message">
      <h1>取引画面</h1>
    </div>
    <div class="tradeInformation">
      <!-- <p>出品者情報:{{selectedItem.seller}}</p>
            <p>購入者情報:</p> -->
      <p>チャットで取引場所や取引時間を決めてください。</p>
      <p>取引現場には、購入者は代金、出品者は商品を持参してください。</p>
      <p>
        出品者の方は取引が完了したら「取引完了」ボタンを押して取引を完了させてください。
      </p>
    </div>
    <div class="AiteInfo">
      <br />
      <div>出品者</div>
      <p>{{ selectedItem.seller }}</p>
      <br />
    </div>
    <div class="chatComponent">
      <div class="inputArea">
        <p>受け渡し場所や日時を決めてください。</p>
        <input type="text" v-model="message" class="message" /><br />
        <button @click="addChat" class="btn send">送信する</button>
      </div>
      <section>
        <div v-for="chat in chats" :key="chat.index" class="messageBoard item">
          <div class="item-name">{{ chat.userName }}</div>
          <div class="item-detail">
            <!-- ユーザ名を表示 -->
            <div class="item-message">
              <!-- テキストを表示 改行コード<br>に変換される。 -->
              <p>{{ chat.message }}</p>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="information">
      <!-- <img :src="selectedItem.img_url" class="Itemphoto" /> -->
      <table>
        <tbody>
          <tr>
            <th colspan="2" class="Iteminfo_title">
                取引情報
            </th>
          </tr>
          <!-- <tr>
            <th>出品者</th>
            <td>{{ selectedItem.seller }}</td>
          </tr> -->
          <tr>
            <th>
                <img :src="selectedItem.img_url" class="Itemphoto" />
            </th>
            <td>{{ selectedItem.item }}</td>
          </tr>
          <tr>
            <th>商品説明</th>
            <td><nl2br tag="div" :text="selectedItem.description" /></td>
          </tr>
          <tr>
            <th>商品の状態</th>
            <td>{{ selectedItem.condition }}</td>
          </tr>
          <tr>
            <th>価格</th>
            <td>{{ selectedItem.price }}円</td>
          </tr>
          <tr>
            <th>商品ID</th>
            <td>{{ selectedItem.itemID }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="this.user.uid === selectedItem.userID" class="deleteButton">
      <p>
        商品を渡しましたか？取引が完了したら下のボタンを押して商品を削除してください。
      </p>
      <button @click="deleteItem" class="btn delete">取引を完了する</button>
    </div>
    <hr />
  </div>
</template>

<script>
import firebase from "firebase";
import db from "../plugins/firestore";
// 改行を <br> タグに変換するモジュール
import Nl2br from "vue-nl2br";
import Header from "../components/Header.vue";

export default {
  components: { Header, Nl2br },
  data() {
    return {
      selectedItem: this.$store.getters.goTrade,
      userID: this.$store.getters.goTrade.userID,
      itemID: this.$store.getters.goTrade.itemID,
      itemName: this.$store.getters.goTrade.item,
      chats: [], //チャットが格納されている配列
      message: "", //メッセージ
      user: "",
    };
  },
  created() {
    firebase.auth().onAuthStateChanged((user) => {
      if (!user) {
        this.$router.push({ path: "/" });
      } else {
        this.user = user;
      }
    });
    this.getChats();
  },
  //chatコレクションにドキュメントが追加される度に（内容が変更されるたびに）getChats()が呼ばれて、
  //チャットデータを取得する。
  //onSnapshot()メソッドでリスナをセットすることで、ドキュメントの変更時にコールバックを受けることが出来る。
  //変更とは、具体的には、追加・削除・変更であり、削除時にはnullが返ってくるものと思われる。
  mounted() {
    db.collection("textbooks")
      .doc(this.itemID)
      .collection("Tradechat")
      .onSnapshot(() => {
        this.getChats();
      });
  },
  methods: {
    //チャットデータ取得
    getChats() {
      //商品のサブコレクションに格納されているチャットの内容を取得
      db.collection("textbooks")
        .doc(this.itemID)
        .collection("Tradechat")
        .orderBy("created", "desc") // 最新のものから取得
        .get()
        .then((querySnapshot) => {
          let chats = [];
          querySnapshot.forEach((doc) => {
            const data = doc.data();
            chats.push({
              userName: data.userName,
              uid: data.uid,
              message: data.message,
              profilePhoto: data.profilePhoto,
              date: data.created,
            });
          });
          this.chats = chats;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    //firestoreにメッセージ内容を保存
    addChat() {
      // メッセージボックスを空に
      if (this.message === "") {
        alert("メッセージを入力してください。");
        return;
      }
      // Firebaseに保存
      //選択中のitemのしたに、サブコレクションとしてchatコレクションを作成し、
      //そこに(message, uid, userName, profilePhoto, created)を持ったドキュメントを追加する。
      db.collection("textbooks")
        .doc(this.itemID)
        .collection("Tradechat")
        .add({
          message: this.message,
          userName: this.user.displayName, //メッセージを入力したユーザ名
          created: firebase.firestore.FieldValue.serverTimestamp(),
        })
        .then(function (docRef) {
          console.log("Document written with ID: ", docRef.id);
        })
        .catch((error) => {
          console.error("Error adding document: ", error);
        });

      //購入者がコメントしたら、出品者におしらせされる。
      if (firebase.auth().currentUser.uid != this.userID) {
        db.collection("users")
          .doc(this.userID)
          .collection("information")
          .doc(this.itemID)
          .set({
            information:
              "取引中の商品「" +
              this.itemName +
              "」に取引メッセージがつきました。「" +
              this.message +
              "」",
            isRead: false, //読まれたかどうか
            timestamp: firebase.firestore.FieldValue.serverTimestamp(), //購入された日時
          });
      }
      //出品者がコメントしたら、購入者にお知らせされる。

      this.doEmpty();
    },

    //送信ボタンが押されたら、inputのボックスを空にする
    doEmpty() {
      this.message = "";
    },

    deleteItem() {
      const result = confirm(
        "取引が完了しましたか？「OK」を押すと、商品が完全に削除されます。"
      );
      if (result) {
        db.collection("textbooks")
          .doc(this.itemID)
          .delete()
          .then(() => {
            console.log("Document successfully deleted!");
            alert("取引が完了しました。");
            this.$router.push({ path: "/" });
          })
          .catch((error) => {
            console.error("Error removing document: ", error);
          });
      }
    },
  },
};
</script>

<style scoped>
/* inputタグのスタイル */
.message {
  width: 20%;
  height: 30px;
  margin: 0 auto;
  padding: 0px 10px;
  border-style: solid;
  border-width: 0.5px;
  border-radius: 10px;
}
b .top-message p {
  margin: 10px 0px;
}
.tradeInformation {
  width: 50%;
  margin-top: 20px;
  padding: 10px 10px;
  background-color: #fffacd;
  margin: 0 auto;
}
.tradeInformation p {
  font-weight: bold;
}

.all{
  background-color: rgba(166, 173, 179, 0.158);
}

img {
  /* width: 15%; */
  margin-top: 15px;
  width: 60px;
  height: 60px;
}

/* 送信ボタンのスタイル */
.send {
  padding: 8px 24px;
  margin: 15px 0;
  color: white;
  background-color: rgba(255, 0, 0, 0.9);
  display: inline-block;
  opacity: 0.8;
  border-radius: 4px;
  text-align: center;
}

.send:hover {
  background-color: rgba(255, 0, 0, 1);
}

.inputArea {
  text-align: center;
}

section {
  width: 20%;
  margin: 0 auto;
}

.list {
  margin-bottom: 100px;
}

.item {
  position: relative;
  display: flex;
  align-items: flex-end;
  margin-bottom: 0.8em;
}

.item-detail {
  margin: 0 0 0 1.4em;
}
.item-name {
  /* background-color: #ffffff; */
  text-align: left;
  border-radius:  25px; 
  width: 50px;
  /* height: 50px;
  padding:10px 20px; */
  /* padding:20px 20px; */
}

.item-message {
  position: relative;
  display: inline-block;
  padding: 0.8em;
  background: #deefe8;
  border-radius: 4px;
  line-height: 1.2em;
}

.item-message::before {
  position: absolute;
  content: " ";
  display: block;
  left: -16px;
  bottom: 12px;
  border: 4px solid transparent;
  border-right: 12px solid #deefe8;
}

.information {
  text-align: center;
}

table {
  margin: 20px auto;
  border-collapse: collapse; /* セルの線を重ねる */
  width: 50%;
  border-color: rgb(255, 255, 255);
  margin-bottom: 30px;
}

th {
  /* background-color: rgb(200, 200, 200); */
  width: 25%;
}

th,
td {
  padding: 5px 10px; /* 余白指定 */
  background-color: rgb(255, 255, 255);

}

.deleteButton {
  text-align: center;
}

.delete {
  background-color: rgba(53, 174, 243, 1);
}

.AiteInfo {
  text-align: center;
  font-size: 20px;
  margin: 0 auto;
}
.AiteInfo div{
    text-align: center;
    margin: 0 auto;
    opacity: 0.8;
}

.AiteInfo p{
    color: rgba(0, 0, 0, 0.637);
    font-weight: 800;
    background-color: rgb(255, 255, 255);
    padding: 10px 0px;
    text-align: center;
    width: 50%;
    margin: 0 auto;
}

.Itemphoto {
  /* width: 20%; */
  object-fit: cover;
  
}

.Iteminfo_title{
    text-align: left;
    color:rgb(66, 73, 71);
    background-color: rgba(255, 252, 247, 0.534);
}

@media all and (max-width: 670px) {
  .message {
    width: 50%;
  }

.AiteInfo{
  text-align: center;
  font-size: 20px;
  width: 100%;
}

.AiteInfo p{
  width: 100%;

}
.AiteInfo div{
    text-align: left;
    margin-left: 10px;
    opacity: 0.8;
    
}

  .tradeInformation {
    width: 90%;
    font-size: 13px;
  }

  section {
    width: 80%;
  }

  .information img {
    width: 60px;
    height: 60px;
    text-align: left;
    object-fit: cover;

  }

  table {
    width: 90%;
  }

  th {
    width: 25%;
    font-size: 12px;
  }

  td {
    font-size: 13px;
  }
}

</style>